import {OccasionType} from '../../../../gql/pwa/graphql.ts';
import styles from '../occasion_modal.module.scss';
import {formatKm} from '../../../../support/format_distance.ts';
import {formatEuro} from '../../../../support/format_currency.ts';
import {__} from '../../../../support/lang/translations.ts';
import React from 'react';
import {Alignment} from '../../../../enums/alignment.ts';
import {TableCell} from '../../../../components/table/table_cell.tsx';
import {Table} from '../../../../components/table/table.tsx';
import {TableRow} from '../../../../components/table/table_row.tsx';

interface OwnProps {
    occasion: OccasionType;
    children?: React.ReactNode;
}

export function OccasionData({occasion, children}: OwnProps) {
    const occasionImage = occasion.pictures?.length && occasion.pictures.length > 0 ? occasion.pictures[0] : null;

    return (
        <>
            <div className={styles.occasion_modal__occasion}>
                <div className={styles.occasion_modal__overview_title}>
                    <h2>{__('occasions.details.leads.titles.occasion_data.title')}</h2>
                </div>
                <div className={styles.occasion_modal__overview_image}>
                    {occasionImage && (
                        <img src={occasionImage} alt={`occasion image ${occasion.brand} ${occasion.model}`} />
                    )}
                </div>

                <Table style={{paddingTop: 0}} alignment={Alignment.Start}>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.leads.titles.occasion_data.brand')}
                            value={occasion.brand}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.leads.titles.occasion_data.model')}
                            value={occasion.model}
                        />
                    </TableRow>
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.leads.titles.occasion_data.mileage')}
                            value={occasion.mileage ? formatKm(occasion.mileage) : ''}
                        />
                    </TableRow>
                    {occasion.price != null && occasion.price !== 0 && (
                        <TableRow columns={1}>
                            <TableCell
                                name={__('occasions.details.leads.titles.occasion_data.price')}
                                value={occasion.price ? formatEuro(occasion.price) : ''}
                            />
                        </TableRow>
                    )}
                </Table>
            </div>
            {children}
        </>
    );
}
